/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData } from "../Request";
export default {
  state: {
    eventAndGroup: [],
    currentEvent: null,
  },
  getters: {
    GetEventAndGroup(state) {
      return state.eventAndGroup;
    },
    GetCurrentEvent(state) {
      return state.currentEvent;
    },
  },
  actions: {
    async GetEventAndGroup({ commit }, payload) {
      try {
        const response = await Post("EventAndGroup/GetEventAndGroupNew", payload);
        commit("SetEventAndGroup", response.data.Data?.List || []);
        return {
          totalRecords: response.data.Data?.TotalRecords || 0,
          page: payload.PageNo || 1
        };
      } catch (error) {
        console.error("Error fetching events:", error);
        commit("SetEventAndGroup", []);
        return { totalRecords: 0, page: 1 };
      }
    },
    async GetEventById({ commit }, id) {
      try {
        const response = await Get(`EventAndGroup/GetEventAndGroupByIdNew?id=${id}`);
        commit("SetCurrentEvent", response.data.Data);
        return response.data.Data;
      } catch (error) {
        console.error("Error fetching event by ID:", error);
        return null;
      }
    },
    async AddEventAndGroup({ commit }, payload) {
      try {
        const response = await Post(`EventAndGroup/AddEventAndGroup`, payload);
        return response.data;
      } catch (error) {
        console.error("Error adding event:", error);
        throw error;
      }
    },
    async EditEventAndGroup({ commit }, payload) {
      try {
        const response = await Post(`EventAndGroup/EditEventAndGroup`, payload);
        return response.data;
      } catch (error) {
        console.error("Error editing event:", error);
        throw error;
      }
    },
    async DeleteEventAndGroup({ commit }, payload) {
      try {
        const response = await Delete(`EventAndGroup/DeleteEventAndGroup/${payload}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting event:", error);
        throw error;
      }
    },
  },
  mutations: {
    SetEventAndGroup(state, payload) {
      state.eventAndGroup = payload;
    },
    SetCurrentEvent(state, payload) {
      state.currentEvent = payload;
    },
  },
};